/* eslint-disable react/no-array-index-key */

import React, { PureComponent } from 'react';
import CheckoutAddressItem from '../item';

import { AddressList } from './styles';

export default class CheckoutAddressList extends PureComponent {
    render() {
        const {
            noMarginBottom,
            list,
            activeId,
            onClick,
            noEdit,
            fetching,
            addressType,
        } = this.props;
        const single = list.length === 1;

        return (
            <AddressList noMarginBottom={noMarginBottom}>
                {list.map((address, index) => {
                    const active = address.id === activeId;

                    return (
                        <CheckoutAddressItem
                            noEdit={noEdit}
                            loading={fetching}
                            active={active}
                            single={active && single}
                            address={address}
                            key={index}
                            onClick={() => !active && onClick(address.id)}
                            editLink={`/checkout/address?modal=address-edit&modal-id=${address.id}&modal-address-type=${addressType}`}
                        />
                    );
                })}
            </AddressList>
        );
    }
}
